import { Image, ImageProps } from '@chakra-ui/react';

import { useLazyImageSrc } from '../utils/hooks';

interface LazyImageProps extends ImageProps {
  placeholderUrl?: string;
}

export const LazyImage = ({ src, placeholderUrl, ...props }: LazyImageProps) => {
  const [ref, imageSrc] = useLazyImageSrc({ url: src || '', placeholderUrl: placeholderUrl || '' });

  return <Image {...props} src={imageSrc} ref={ref} />;
};
